// import { B__Alpine } from './b--alpine/B__Alpine';
import { B__Qumano } from './b--qumano/B__Qumano';
import { B__RecommendedProducts } from './b--recommended-products/B__RecommendedProducts';
import { B__BannerFeaturedProducts } from './b--banner-featured-products/B__BannerFeaturedProducts';

import { B__BannerCases } from './b--banner-cases/B__BannerCases';

import { B__BannerTestimonials } from './b--banner-testimonials/B__BannerTestimonials';
import { B__PublicationsModule } from './b--publications/module';

export const Blocks = {
    directives: {},
    modules: {
        // B__Alpine,
        B__Qumano,
        B__RecommendedProducts,
        B__BannerCases,
        B__BannerTestimonials,
        B__BannerFeaturedProducts,
        B__PublicationsModule
    }
};
